import './App.css';
import ProductList from './components/ProductList'
import Cart from './components/Cart';
import { BrowserRouter,Routes ,Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<ProductList/>}/>
          <Route path='cart' element={<Cart/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  ); 
}

export default App;
